import { useState, useContext } from "react";
import {
  Download,
  FileText,
  Image,
  FileIcon,
  Film,
  Music,
  Search,
  Filter,
  ChevronDown,
  X,
  Eye,
} from "lucide-react";

export default function FileManager({
  activeAgent,
  user,
  fallBackDetails,
  webhookAgentUrl,
  companyName,
  actions,
  setMessages,
}) {
  let WEBHOOK_URL = webhookAgentUrl; //"https://avaneesh05060.app.n8n.cloud/webhook/charlotte";

  console.log("file-manager WEBHOOK_URL->>>", WEBHOOK_URL);

  /*let WEBHOOK_URL = "https://avaneesh05060.app.n8n.cloud/webhook/charlotte";

  if (activeAgent.description === "Secretary") {
    WEBHOOK_URL = "https://avaneesh05060.app.n8n.cloud/webhook/charlotte";

  } else if (activeAgent.description === "Accountant") {
    WEBHOOK_URL =
      "https://avaneesh05060.app.n8n.cloud/webhook/8f81192a-8ab8-493d-b8c7-eaf85eff7968";

  } else if (activeAgent.description === "Trainer") {
    WEBHOOK_URL =
      "https://avaneesh05060.app.n8n.cloud/webhook/edf5b267-e6de-4323-bfdf-eb1c4ee59ef5";

  } else if (activeAgent.description === "Assistant") {
    WEBHOOK_URL =
      "https://avaneesh05060.app.n8n.cloud/webhook/20df5727-3b46-4748-9cc0-4fd5e13ae785";
  }*/

  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [showFilterMenu, setShowFilterMenu] = useState(false);

  // Sample static files with properties
  const files = [
    {
      id: 1,
      name: "Project Proposal.pdf",
      type: "pdf",
      size: "2.4 MB",
      modified: "2025-04-12",
      owner: "Alex Miller",
      icon: <FileText size={20} />,
    },
    {
      id: 2,
      name: "Company Logo.png",
      type: "image",
      size: "0.8 MB",
      modified: "2025-04-10",
      owner: "Sarah Johnson",
      icon: <Image size={20} />,
    },
  ];

  const getTypeColor = (type) => {
    const colors = {
      pdf: "bg-red-100 text-red-800",
      image: "bg-green-100 text-green-800",
      excel: "bg-emerald-100 text-emerald-800",
      video: "bg-blue-100 text-blue-800",
      document: "bg-indigo-100 text-indigo-800",
      presentation: "bg-orange-100 text-orange-800",
      audio: "bg-purple-100 text-purple-800",
    };
    return colors[type] || "bg-gray-100 text-gray-800";
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const downloadFile = (fileId) => {
    console.log(`Downloading file with ID: ${fileId}`);
    // In a real application, this would trigger the file download
  };

  const previewFile = (fileId) => {
    console.log(`Previewing file with ID: ${fileId}`);
    // In a real application, this would open a preview modal
  };

  const filteredFiles = files.filter((file) => {
    // Filter by file type
    if (filterType !== "all" && file.type !== filterType) {
      return false;
    }

    // Filter by search query
    if (
      searchQuery &&
      !file.name.toLowerCase().includes(searchQuery.toLowerCase())
    ) {
      return false;
    }

    return true;
  });

  // Get unique file types for filter dropdown
  const fileTypes = ["all", ...new Set(files.map((file) => file.type))];

  const [file, setFile] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadError, setUploadError] = useState(false);
  const [extractedText, setExtractedText] = useState("");

  const getCurrentPacificDateTime = () => {
    const now = new Date();
    const pacificTime = new Date(
      now.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    );
    const year = pacificTime.getFullYear();
    const month = String(pacificTime.getMonth() + 1).padStart(2, "0");
    const day = String(pacificTime.getDate()).padStart(2, "0");
    const hours = String(pacificTime.getHours()).padStart(2, "0");
    const minutes = String(pacificTime.getMinutes()).padStart(2, "0");
    const seconds = String(pacificTime.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const getCurrentTime = () => {
    return new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const userData = {
    user_id: user?.user_id,
    user_email: user?.email ?? fallBackDetails?.email,
    first_name: user?.first_name ?? fallBackDetails?.userName?.split(" ")[0],
    last_name: user?.last_name ?? fallBackDetails?.userName?.split(" ")[1],
    access_token: user?.access_token,
    location_id: user?.location_id,
    company_name: companyName,
    today_date: getCurrentPacificDateTime(),
  };

  const sessionId = String(
    user?.user_id ?? fallBackDetails?.email ?? `guest_${Date.now()}`
  );

  const sendFileToChatbot = async (file, userData, sessionId) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", "file");
      formData.append("userData", JSON.stringify(userData));
      formData.append("sessionId", sessionId);

      const response = await fetch(WEBHOOK_URL, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.text();
      console.log("Chatbot response data:", data);
      const botResponse = (data || "Sorry, no response from chatbot.").replace(
        /\n/g,
        "<br/>"
      );

      setMessages((prevMessages) => [
        ...prevMessages,
        { text: botResponse, sender: "bot", time: getCurrentTime() },
      ]);

      //   const chatData = {
      //     message: botResponse,
      //     sender_type: "agent",
      //     user_id: user?.user_id,
      //     agent_id: activeAgent.description,
      //     session_id: sessionId,
      //   };

      //   saveChatMessageInDb(chatData);
    } catch (error) {
      console.error("Error uploading file:", error);
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          text: "⚠️ Failed to upload file. Please try again.",
          sender: "bot",
          time: getCurrentTime(),
        },
      ]);
    }
  };

  const handleFileChange = async (e) => {
    const uploadedFile = e.target.files[0];

    if (!uploadedFile) return;

    setFile(uploadedFile);
    setIsProcessing(true);
    setUploadSuccess(false);
    setUploadError(false);

    const fileName = uploadedFile.name || "unknown";
    const extension = fileName.includes(".")
      ? fileName.split(".").pop().toLowerCase()
      : "";

    //console.log('File extension:', extension);

    const formData = new FormData();
    //formData.append("conversation_id", "test");
    //formData.append("user_id", "test");
    formData.append("file", uploadedFile);
    formData.append("filename", uploadedFile.name);
    formData.append("filetype", uploadedFile.name.split(".").pop());
    formData.append("type", "file");
    formData.append("userData", JSON.stringify(userData));
    formData.append("sessionId", sessionId);
    formData.append("extension", extension);

    try {
      const response = await fetch(WEBHOOK_URL, {
        method: "POST",
        body: formData,
      });

      //const result = await response.json();

      if (!response.ok) {
        throw new Error("Upload failed");
      }

      const data = await response.text();
      const botResponse = (data || "Sorry, no response from chatbot.").replace(
        /\n/g,
        "<br/>"
      );

      //console.log('botResponse', botResponse);
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: botResponse, sender: "bot", time: getCurrentTime() },
      ]);
      //if (response.ok && result.success) {
      if (response) {
        //setExtractedText(result.text);

        // console.log(botpress);
        // console.log("Upload File Event", {name:"FILE_UPLOADED",filename:uploadedFile.name, file_content: result.text})
        //const uploadFile = await botpress.sendEvent({name:"FILE_UPLOADED",filename:uploadedFile.name, file_content: result.text, user_id: botpress.user.data.user_id});
        setIsProcessing(false);
        setUploadSuccess(true);

        setTimeout(() => {
          actions.toggleFilesPopup();
        }, 2000);
      } else {
        throw new Error("Server returned error");
      }
    } catch (err) {
      console.error(err);
      setUploadError(true);
    } finally {
      setIsProcessing(false);
    }
  };

  const x_handleFileChange = async (e) => {
    const uploadedFile = e.target.files[0];

    if (!uploadedFile) return;

    setFile(uploadedFile);
    setIsProcessing(true);
    setUploadSuccess(false);
    setUploadError(false);

    const formData = new FormData();
    formData.append("conversation_id", "test");
    formData.append("user_id", "test");
    formData.append("file", uploadedFile);
    formData.append("filename", uploadedFile.name);
    formData.append("filetype", uploadedFile.name.split(".").pop());

    try {
      const response = await fetch(
        "https://avaneesh0506.app.n8n.cloud/webhook/8f81192a-8ab8-493d-b8c7-eaf85eff7968",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error("Upload failed");
      }

      if (response.ok && result.success) {
        setExtractedText(result.text);

        // console.log(botpress);
        // console.log("Upload File Event", {name:"FILE_UPLOADED",filename:uploadedFile.name, file_content: result.text})
        //const uploadFile = await botpress.sendEvent({name:"FILE_UPLOADED",filename:uploadedFile.name, file_content: result.text, user_id: botpress.user.data.user_id});
        setIsProcessing(false);
        setUploadSuccess(true);

        setTimeout(() => {
          actions.toggleFilesPopup();
        }, 2000);
      } else {
        throw new Error("Server returned error");
      }
    } catch (err) {
      console.error(err);
      setUploadError(true);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
      <div className="bg-gradient-to-r from-purple-600 to-indigo-600 p-6">
        <h1 className="text-2xl font-bold text-white">Upload files</h1>
      </div>

      <div className="p-6">
        <div className="p-4 max-w-md mx-auto">
          <label className="form-control w-full">
            <div className="label">
              <span className="label-text font-semibold">Upload your file</span>
            </div>
            <input
              type="file"
              accept=".pdf, .csv, .xls, .xlsx"
              className="file-input file-input-bordered w-full"
              onChange={handleFileChange}
            />
          </label>

          {file && (
            <div className="mt-4 p-3 bg-base-200 rounded-md">
              <p className="font-medium">Selected file:</p>
              <p className="text-sm text-gray-600">{file.name}</p>
            </div>
          )}

          {isProcessing && (
            <div className="mt-4 alert alert-info shadow-sm">
              <span>
                <span className="loading loading-spinner mr-2"></span>
                The file is processing, please wait and do not close the popup.
              </span>
            </div>
          )}

          {uploadSuccess && (
            <div className="mt-4 alert alert-success">
              <span>✅ File uploaded successfully!</span>
            </div>
          )}

          {uploadError && (
            <div className="mt-4 alert alert-error">
              <span>❌ There was an error uploading the file.</span>
            </div>
          )}

          <p className="mt-4 text-xs text-gray-500 text-center">
            * PDF, CSV, XLS, and XLSX files are supported.
          </p>
        </div>
      </div>
    </div>
  );
}
